import { ResponseGeneratedSection } from './reports';

export type ResponseDeleteSection = {
  message: string;
};

export interface SectionsMixin {
  fetch(path: string, init?: RequestInit): Promise<any>;
  createSection(
    sessionId: number,
    templateId: number,
    title: string,
    prompt: string,
    order: number
  ): Promise<ResponseGeneratedSection>;
  updateSection(
    sessionId: number,
    templateId: number,
    sectionId: number,
    title: string,
    prompt: string,
    order: number
  ): Promise<ResponseGeneratedSection>;
  deleteSection(
    sessionId: number,
    templateId: number,
    sectionId: number
  ): Promise<ResponseDeleteSection>;
}
export const SectionsMixin = {
  async fetch(path: string, init?: RequestInit): Promise<any> {
    throw new Error('Not implemented');
  },
  async createSection(
    sessionId: number,
    templateId: number,
    title: string,
    prompt: string,
    order: number
  ): Promise<ResponseGeneratedSection> {
    const section = await this.fetch(`/sessions/${sessionId}/templates/${templateId}/sections`, {
      method: 'post',
      body: JSON.stringify({
        title,
        prompt,
        order,
      }),
    });
    return section;
  },
  async updateSection(
    sessionId: number,
    templateId: number,
    sectionId: number,
    title: string,
    prompt: string,
    order: number
  ): Promise<ResponseGeneratedSection> {
    const section = await this.fetch(
      `/sessions/${sessionId}/templates/${templateId}/sections/${sectionId}`,
      {
        method: 'put',
        body: JSON.stringify({
          title,
          prompt,
          order,
        }),
      }
    );
    return section;
  },
  async deleteSection(
    sessionId: number,
    templateId: number,
    sectionId: number
  ): Promise<ResponseDeleteSection> {
    const section = await this.fetch(
      `/sessions/${sessionId}/templates/${templateId}/sections/${sectionId}`,
      {
        method: 'delete',
      }
    );
    return section;
  },
} as SectionsMixin;
